/** Compact timestamp for evidence rows, e.g. "Jun 24, 02:31 PM". */
export function formatWhen(iso: string): string {
    return new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

/** A [0,1] fraction as a whole percent, e.g. "82%". Null renders as an em dash. */
export function formatPct(fraction: number | null): string {
    return fraction === null ? '—' : `${Math.round(fraction * 100)}%`;
}
